import {Brick, registerBrick} from 'olympe';
// eslint-disable-next-line no-unused-vars
import {TimeoutMap} from '@olympeio/core';

/**
 * This brick get a value from a TimeoutMap
 */
export default class GetFromTimeoutMap extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {TimeoutMap} timeoutMap
     * @param {*} key
     * @param {function(*)} setValue
     */
    update($, [timeoutMap, key], [setValue]) {
        setValue(timeoutMap.get(key));
    }
}

registerBrick('0192e322d323146251ec', GetFromTimeoutMap);
